var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"head"}),_vm._m(0),_c('div',{staticClass:"collection d-flex flex-row"},[_c('wp-job')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container d-flex flex-column"},[_c('h1',{staticClass:"title"},[_vm._v("Nos métiers")])])
}]

export { render, staticRenderFns }